module.exports = __webpack_public_path__ + "img/sell-orange.6d46cfdd.svg";